import React from 'react';

import { Button, buttonClasses, ButtonProps, styled } from '@mui/material';

import { SelectArrowDownIcon } from '@mewa/ui';

type Props = ButtonProps & {
  hasOpenMenu: boolean;
};

const QuickNavMenuButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, hasOpenMenu, ...rest }, ref) => (
    <StyledMenuButton
      ref={ref}
      variant="contained"
      className={hasOpenMenu ? 'quick-nav-button-active' : undefined}
      endIcon={<SelectArrowDownIcon />}
      {...rest}
    >
      {children}
    </StyledMenuButton>
  ),
);

export default QuickNavMenuButton;

const StyledMenuButton = styled(Button)(({ theme }) => ({
  ...theme.typography.h6,
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  border: 'none',
  outline: '1px solid var(--color-medium-light-grey)',
  outlineOffset: '-1px',
  backgroundColor: 'white',
  color: 'var(--color-dark-coal)',

  transition: 'background-color 0.2s linear, box-shadow 0.2s',
  textAlign: 'left',

  [`.${buttonClasses.endIcon}`]: {
    marginTop: '8px',
    svg: {
      transition: 'transform 0.3s ease',
      color: theme.palette.primary.main,
    },
  },

  [`&.${buttonClasses.contained}.${buttonClasses.colorPrimary}:hover, 
  &.${buttonClasses.contained}.${buttonClasses.colorPrimary}:active, 
  &.${buttonClasses.contained}.${buttonClasses.colorPrimary}:focus, 
  &.quick-nav-button-active`]: {
    backgroundColor: 'var(--color-white)',
    color: 'var(--color-light-red)',
  },

  '&.quick-nav-button-active': {
    boxShadow: '0 1px var(--color-medium-light-grey)', // hide the gap between button and menu due to rounding issues.

    [`.${buttonClasses.endIcon} svg`]: {
      transform: 'rotate(180deg)',
    },

    [`.`]: {
      transform: 'rotate(180deg)',
    },
  },
}));
